import { render, staticRenderFns } from "./OrgSpheresPicker.vue?vue&type=template&id=44cec3e8&lang=pug&"
import script from "./OrgSpheresPicker.vue?vue&type=script&lang=js&"
export * from "./OrgSpheresPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports